import React, { Component } from 'react';
import Upload from './upload';

export default class MainUpload extends Component {
    render() {
        return (
            <div>
                <div className="row justify-content-center h-100 expansaoDiv">
                    <div className="col-12 col-sm-11 col-md-9 col-lg-10 col-xl-8">
                        <Upload/>
                    </div>
                </div>
            </div>
        );
    }
}